const constants = {
  ACTIVITY_STORE_MODULE_NAME: 'featureActivity',
}
export default constants
